module.exports = __webpack_public_path__ + "static/lastMail-2833e2c1a5aec78f5adc37477ef05663.png";